import React, { useEffect, useRef, useState } from 'react';
import { useIntel } from '../IntelContext';

const R1 =
  'HLE Glascoat recently commissioned a new furnace line at their Anand facility, lifting capacity from 55 to 80 EU/month. They are aggressively targeting the small vessel segment with pricing ~12-15% below GMM list price and have reduced delivery lead times to ~10 weeks vs the industry average of 14 weeks.';

const R2 =
  "Divi's Laboratories has board-approved ₹1,200Cr capex for Vizag Unit III — 40 new glass-lined reactor vessels, 18-month timeline, completion Q3 FY2028. Aarti Industries CFO confirmed ₹800Cr Dahej SEZ capex in FY27, with RFQ process starting Q1 FY27. Both represent active pipeline opportunities for GMM India.";

const R3 =
  "PLI Phase 2 disbursed ₹3,400Cr to 34 API manufacturers — 12 in Gujarat, 14 in Andhra Pradesh. Scheme mandates capacity expansion within 24 months, creating direct equipment demand. CPCB's Oct 2026 effluent norm deadline affects 180+ pharma plants, forcing replacement of pre-2018 glass-lined equipment. Combined, these two regulatory triggers represent the largest demand signal in the current cycle.";

const R4 =
  "The Gujarat cluster — Ankleshwar, Dahej SEZ, Vatva, Vapi — accounts for the majority of GMM India's domestic order book. Current active signals: Aarti Industries (Dahej, FY27 RFQ), Deepak Nitrite (Vadodara expansion), Alkyl Amines (capacity addition). HLE Glascoat's Anand facility is also in this cluster, making it the primary competitive battleground.";

const R_DEFAULT =
  "Based on tracked intelligence across GMM India's competitor and customer universe, the most active signals currently are: Divi's ₹1,200Cr Vizag capex, HLE Glascoat capacity expansion at Anand, PLI Phase 2 disbursements triggering mandatory expansion for 34 API companies, and CPCB Oct 2026 compliance deadline creating replacement demand across 180+ pharma plants.";

function pickResponse(raw) {
  const q = String(raw || '').toLowerCase();
  if (q.includes('hle') || q.includes('competitor') || q.includes('capacity')) return R1;
  if (q.includes('capex') || q.includes('customer') || q.includes('divi') || q.includes('aarti'))
    return R2;
  if (
    q.includes('pli') ||
    q.includes('regulatory') ||
    q.includes('cpcb') ||
    q.includes('norm')
  )
    return R3;
  if (q.includes('gujarat') || q.includes('cluster') || q.includes('dahej')) return R4;
  return R_DEFAULT;
}

const CHIP_SUGGESTIONS = [
  'What are the recent competitive moves by ABB?',
  'How is Honeywell positioning in the Indian pharma market?',
  'Latest capex announcements from key customers',
];

function TypingDots() {
  return (
    <span className="braga-dots" aria-hidden>
      <span className="braga-dot" />
      <span className="braga-dot" />
      <span className="braga-dot" />
    </span>
  );
}

const AskBragaPage = ({ intelBridge }) => {
  const { toast } = useIntel();
  const [query, setQuery] = useState('');
  const [messages, setMessages] = useState([]);
  const [typing, setTyping] = useState(false);
  const listRef = useRef(null);
  const appliedNonceRef = useRef(-1);

  useEffect(() => {
    const n = intelBridge?.nonce;
    const q =
      intelBridge?.bragaQuery != null && intelBridge?.bragaQuery !== ''
        ? String(intelBridge.bragaQuery)
        : null;
    if (intelBridge?.tab !== 'braga' || !q || n === appliedNonceRef.current || typeof n !== 'number') {
      return;
    }
    appliedNonceRef.current = n;
    setQuery(q);
    runSubmission(q);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- runSubmission stable via closure intentionally not listed
  }, [intelBridge?.nonce, intelBridge?.tab, intelBridge?.bragaQuery]);

  useEffect(() => {
    const el = listRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages, typing]);

  function runSubmission(text) {
    const trimmed = String(text || '').trim();
    if (!trimmed) return;
    const userBubble = { id: `u-${Date.now()}`, role: 'user', text: trimmed };
    setMessages((m) => [...m, userBubble]);
    setQuery('');
    setTyping(true);
    window.setTimeout(() => {
      const answer = pickResponse(trimmed);
      const bragaBubble = { id: `a-${Date.now()}`, role: 'braga', text: answer };
      setTyping(false);
      setMessages((m) => [...m, bragaBubble]);
    }, 1000);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    runSubmission(query);
  };

  const chipClick = (text) => {
    setQuery(text);
    runSubmission(text);
  };

  const clearConversation = () => {
    setMessages([]);
    setQuery('');
    setTyping(false);
  };

  const hasChat = messages.length > 0 || typing;

  return (
    <div className={`ask-braga-page ${hasChat ? 'ask-braga-page--chat' : ''}`}>
      {!hasChat ? (
        <>
          <div className="braga-logo">
            <svg className="braga-icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <circle cx="50" cy="50" r="45" fill="#2563EB" />
              <circle cx="50" cy="50" r="35" fill="#fff" opacity="0.2" />
              <text x="50" y="65" textAnchor="middle" fill="#fff" fontSize="48" fontWeight="bold">
                Q
              </text>
              <circle cx="75" cy="25" r="8" fill="#FFD700" />
              <path d="M78 22 L82 18" stroke="#FFD700" strokeWidth="2" />
              <path d="M80 25 L85 25" stroke="#FFD700" strokeWidth="2" />
              <path d="M78 28 L82 32" stroke="#FFD700" strokeWidth="2" />
            </svg>
          </div>

          <form className="braga-search-form" onSubmit={handleSubmit}>
            <div className="braga-search-bar">
              <button
                type="button"
                className="braga-icon-btn voice-btn voice-btn--icon"
                title="Voice input"
                aria-label="Voice input"
                onClick={() => toast('Voice input coming soon')}
              />

              <input
                type="text"
                className="braga-input"
                placeholder="Ask Braga..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />

              <div className="braga-tag">Facts and Insights</div>

              <button
                type="submit"
                className="braga-icon-btn search-btn search-btn--icon"
                title="Search"
                aria-label="Search"
              />
            </div>
          </form>

          <div className="suggested-questions">
            {CHIP_SUGGESTIONS.map((chip) => (
              <button
                key={chip}
                type="button"
                className="suggestion-chip"
                onClick={() => chipClick(chip)}
              >
                {chip}
              </button>
            ))}
          </div>
        </>
      ) : (
        <>
          <button type="button" className="braga-clear" onClick={clearConversation}>
            Clear conversation
          </button>

          <div ref={listRef} className="braga-chat-list">
            {messages.map((m) =>
              m.role === 'user' ? (
                <div key={m.id} className="braga-msg braga-msg--user">
                  <div className="braga-msg-bubble braga-msg-bubble--user">{m.text}</div>
                </div>
              ) : (
                <div key={m.id} className="braga-msg braga-msg--braga">
                  <div className="braga-msg-label">Braga</div>
                  <div className="braga-msg-bubble braga-msg-bubble--braga">{m.text}</div>
                </div>
              ),
            )}
            {typing ? (
              <div className="braga-msg braga-msg--braga">
                <div className="braga-msg-label">Braga</div>
                <div className="braga-msg-bubble braga-msg-bubble--braga braga-msg-bubble--typing">
                  <TypingDots />
                </div>
              </div>
            ) : null}
          </div>

          <div className="braga-chat-footer">
            <form className="braga-chat-form" onSubmit={handleSubmit}>
              <div className="braga-search-bar braga-search-bar--compact">
                <button
                  type="button"
                  className="braga-icon-btn voice-btn voice-btn--icon"
                  title="Voice input"
                  aria-label="Voice input"
                  onClick={() => toast('Voice input coming soon')}
                />

                <input
                  type="text"
                  className="braga-input"
                  placeholder="Ask Braga..."
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />

                <div className="braga-tag">Facts and Insights</div>

                <button
                  type="submit"
                  className="braga-icon-btn search-btn search-btn--icon"
                  title="Send"
                  aria-label="Send"
                />
              </div>
            </form>
          </div>
        </>
      )}
    </div>
  );
};

export default AskBragaPage;
